"use client"

import { useUser } from "@clerk/nextjs"
import { DEV_BYPASS_CLERK } from "src/auth/dev-bypass"

interface ClerkCreatedAt {
  /** When the account was created, or undefined if signed out / unavailable. */
  createdAt: Date | undefined
  /** `false` only while Clerk is still resolving; `true` once resolved, or immediately in dev bypass mode. */
  isLoaded: boolean
}

// Clerk is the only source of a user's signup time — the Seam session response
// (`/internal/sessions/get`) doesn't include created_at.
function useClerkCreatedAtClerk(): ClerkCreatedAt {
  const { user, isLoaded } = useUser()
  return { createdAt: user?.createdAt ?? undefined, isLoaded }
}

// Dev-only: the Clerk bypass mounts no ClerkProvider, so Clerk hooks would
// throw. There is no Clerk to wait for, hence `isLoaded: true`. Selected at
// module load to avoid conditionally calling `useUser`, which would violate
// hooks rules — same shape as use-ensure-seam-session.ts.
const DEV_BYPASS_RESULT: ClerkCreatedAt = {
  createdAt: undefined,
  isLoaded: true,
}

export const useClerkCreatedAt: () => ClerkCreatedAt = DEV_BYPASS_CLERK
  ? () => DEV_BYPASS_RESULT
  : useClerkCreatedAtClerk
